var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var heading = require('../components/heading');
var modal = require('../layout/components/modal');
var incidentsPerShiftModal = require ('./incidentsPerShiftModal')

var reports = {};

reports.oninit = function () {
  var ctrl = this;
  document.title = 'nimrod | Reports';
  header.vm.activeTab('Reports');

  ctrl.init = function () {
    return  loaders.requestWithLoader({
      url: "api/v1/reportfolder/",
      method: "GET",
    }).then(function(result){
      ctrl.reports =result
    })
  }
  
  ctrl.init();
  
  modal.on('closed', ctrl.init);
}

reports.onremove = function () {
  modal.off('closed', this.init);
};

reports.view = function () {
  var ctrl = this
  if (!ctrl.reports){
    return m('div')
  }
  return m('div', [
    m(heading, {label: 'System Report', class: 'f-subheadline mh3 mb3 pb1 display'}),
    m('div.fl.w-100.w-50-ns.w-25-l.ph3', {onclick: incidentsPerShiftModal.editDialogue.bind(incidentsPerShiftModal)},[
      m('div.flex.justify-between.items-center.ba.b--mid-gray.bw1.pa2.mb3.f6.blue', [
        'Incidents Per Shift',
        m('i.ion-android-list')
      ]),
    ]),
  ])
};

module.exports = reports;